import { render, staticRenderFns } from "./ListaAfiliados.vue?vue&type=template&id=08896ac6&"
import script from "./ListaAfiliados.vue?vue&type=script&lang=js&"
export * from "./ListaAfiliados.vue?vue&type=script&lang=js&"
import style0 from "./ListaAfiliados.vue?vue&type=style&index=0&id=08896ac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VIcon})
